// BehaviorForm.js
import React, { useState } from 'react';

const BASE_URL = process.env.REACT_APP_API_URL;

const BehaviorForm = ({ onSubmit }) => {
  const [category, setCategory] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category.trim()) {
      alert('Category name is required.');
      return;
    }

    const newBehavior = {
      column1: category.trim()
    };

    try {
      const response = await fetch(`${BASE_URL}/engage/api/csv/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newBehavior),
      });

      if (response.ok) {
        alert('Behavior submitted successfully.');
        setCategory('');
      } else {
        const errorText = await response.text();
        console.error('Server error:', errorText);
        alert('Failed to submit behavior.');
      }
    } catch (error) {
      console.error('Error submitting behavior:', error);
      alert('Error submitting behavior.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6 bg-gray-50 p-4 rounded shadow">
      <h3 className="text-lg font-semibold mb-2">Submit New Behavior</h3>

      <input
        type="text"
        placeholder="Category Name"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        className="block w-full border px-3 py-2 mb-4"
      />

      <button
        type="submit"
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Add Behavior
      </button>
    </form>
  );
};

export default BehaviorForm;
